


import React, { useState, useEffect } from 'react';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';

const consultants = [
  { name: 'Meera Krishnan', role: 'Luxury & Leisure Travel', exp: '12 years', location: 'Hyderabad', speciality: 'Rajasthan · Kerala · Maldives' },
  { name: 'Arjun Kapoor', role: 'Corporate Travel Lead', exp: '9 years', location: 'Hyderabad', speciality: 'Corporate Policy · Group Travel' },
  { name: 'Sunita Verma', role: 'Visa Consultancy Expert', exp: '11 years', location: 'Hyderabad', speciality: 'UK · USA · Schengen · Canada' },
  { name: 'Rohit Shetty', role: 'Flights & Fares Specialist', exp: '8 years', location: 'Hyderabad', speciality: 'Domestic · International Fares' },
];

const stats = [
  { value: '10+', label: 'Years of Experience', desc: 'Trusted travel partner since 2014' },
  { value: '5,000+', label: 'Happy Travellers', desc: 'Across India and international' },
  { value: '50+', label: 'Indian Destinations', desc: 'Covered with expert knowledge' },
  { value: '24/7', label: 'Travel Support', desc: 'Always on call for you' },
];

export default function About() {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= 768 : true
  );

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sectionLabelStyle = {
    fontSize: '13px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: 'var(--gold, #F47B20)',
    marginBottom: '12px',
    fontFamily: 'Manrope, sans-serif',
  };

  return (
    <>

      <Nav />
      <div style={{ minHeight: '100vh', background: 'var(--bg, #f8fafc)', fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)' }}>
        {/* Hero */}
        <div
          style={{
            background: 'var(--navy, #0a192f)',
            paddingTop: '80px',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'radial-gradient(ellipse at 30% 60%, rgba(244,123,32,0.35) 0%, transparent 60%)',
            }}
          />
          <div
            style={{
              position: 'relative',
              zIndex: 10,
              maxWidth: '1280px',
              margin: '0 auto',
              padding: '64px 24px',
              boxSizing: 'border-box',
            }}
          >
            <div style={{ maxWidth: '672px' }}>
              <p style={sectionLabelStyle}>About Aerova Travels</p>
              <h1
                style={{
                  fontSize: isDesktop ? '48px' : '36px',
                  fontWeight: 800,
                  color: '#ffffff',
                  marginBottom: '20px',
                  lineHeight: 1.1,
                  fontFamily: 'Manrope, sans-serif',
                }}
              >
                Travel Is Personal.
                <br />
                <span
                  style={{
                    background: 'linear-gradient(90deg, #F47B20 0%, #FFB020 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  So Is Our Service.
                </span>
              </h1>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '16px', lineHeight: '1.6', margin: 0 }}>
                We are a team of passionate travel consultants who believe that every great journey starts with a real conversation — not a search algorithm.
              </p>
            </div>
          </div>
        </div>

        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '64px 24px', boxSizing: 'border-box' }}>
          {/* Who We Are */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isDesktop ? '1fr 1fr' : '1fr',
              gap: '48px',
              alignItems: 'center',
              marginBottom: '80px',
            }}
          >
            <div>
              <p style={sectionLabelStyle}>Who We Are</p>
              <h2
                style={{
                  fontSize: '30px',
                  fontWeight: 800,
                  marginBottom: '20px',
                  fontFamily: 'Manrope, sans-serif',
                  color: 'var(--navy, #0a192f)',
                }}
              >
                An Indian Travel Company Built on Expertise
              </h2>
              <p style={{ fontSize: '15px', lineHeight: '1.6', marginBottom: '20px', color: 'var(--text-secondary, #4a5568)' }}>
                Aerova Travels was founded in 2014 in Hyderabad by a group of travel professionals who were tired of impersonal, transactional booking platforms. We set out to build a travel company that combines the warmth of a local consultant with the efficiency of a modern digital platform.
              </p>
              <p style={{ fontSize: '15px', lineHeight: '1.6', marginBottom: '20px', color: 'var(--text-secondary, #4a5568)' }}>
                Today, we serve thousands of Indian travellers — individuals, families, honeymooners, business professionals and corporate clients — all from our base in Hyderabad.
              </p>
              <p style={{ fontSize: '15px', lineHeight: '1.6', margin: 0, color: 'var(--text-secondary, #4a5568)' }}>
                Every client speaks to a real, experienced travel consultant who takes the time to understand their needs. That is not something a search engine can do.
              </p>
            </div>
            <div style={{ position: 'relative' }}>
              <div style={{ borderRadius: '16px', overflow: 'hidden', height: '320px', backgroundColor: '#e2e8f0' }}>
                <img
                  src="https://images.unsplash.com/photo-1715405155683-e36aff15fd53?w=700&h=500&fit=crop&auto=format"
                  alt="Luxury travel experience"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
              </div>
            </div>
          </div>

          {/* Stats */}
          <div
            style={{
              borderRadius: '16px',
              padding: '32px',
              marginBottom: '80px',
              display: 'grid',
              gridTemplateColumns: isDesktop ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)',
              gap: '32px',
              background: 'var(--navy, #0a192f)',
            }}
          >
            {stats.map((s) => (
              <div key={s.label} style={{ textAlign: 'center' }}>
                <p
                  style={{
                    fontSize: '36px',
                    fontWeight: 800,
                    marginBottom: '4px',
                    margin: 0,
                    fontFamily: 'Manrope, sans-serif',
                    color: 'var(--gold, #F47B20)',
                  }}
                >
                  {s.value}
                </p>
                <p style={{ fontWeight: 700, color: '#ffffff', fontSize: '14px', marginBottom: '4px', marginTop: '4px', fontFamily: 'Manrope, sans-serif' }}>
                  {s.label}
                </p>
                <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', margin: 0 }}>{s.desc}</p>
              </div>
            ))}
          </div>

          {/* Why Choose Aerova */}
          <div style={{ marginBottom: '80px' }}>
            <div style={{ textAlign: 'center', marginBottom: '40px' }}>
              <p style={sectionLabelStyle}>Why Choose Us</p>
              <h2
                style={{
                  fontSize: '30px',
                  fontWeight: 800,
                  fontFamily: 'Manrope, sans-serif',
                  color: 'var(--navy, #0a192f)',
                  margin: 0,
                }}
              >
                Our Commitment to You
              </h2>
            </div>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isDesktop ? 'repeat(3, 1fr)' : '1fr',
                gap: '20px',
              }}
            >
              {[
                { icon: '🤝', title: 'Customer First Approach', desc: "Every decision we make is guided by what's best for you — not our margin. We recommend the right option, not the most expensive one." },
                { icon: '🔒', title: 'Transparent & Honest', desc: 'Full pricing including GST upfront. No last-minute surprises. No hidden charges. No unclear terms.' },
                { icon: '📱', title: 'Always Reachable', desc: "Your travel consultant's direct number. WhatsApp. Email. Whatever works for you — we're accessible." },
                { icon: '🏆', title: 'Certified Expertise', desc: 'IATA accredited travel agency with direct airline access, hotel preferred partner status, and corporate negotiated fares.' },
                { icon: '🇮🇳', title: 'Deep India Knowledge', desc: 'We know India intimately — from Kashmir to Kanyakumari. Our consultants have personally visited most destinations we recommend.' },
                { icon: '❤️', title: 'Long-Term Relationships', desc: 'Most of our clients have been with us for years. We know their preferences, their families, their travel style.' },
              ].map((f) => (
                <div
                  key={f.title}
                  style={{
                    padding: '24px',
                    borderRadius: '12px',
                    background: 'var(--white, #ffffff)',
                    border: '1px solid var(--border, #e2e8f0)',
                    boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                  }}
                >
                  <span style={{ fontSize: '30px', display: 'block', marginBottom: '12px' }}>{f.icon}</span>
                  <h3
                    style={{
                      fontWeight: 700,
                      fontSize: '15px',
                      marginBottom: '8px',
                      marginTop: 0,
                      fontFamily: 'Manrope, sans-serif',
                      color: 'var(--navy, #0a192f)',
                    }}
                  >
                    {f.title}
                  </h3>
                  <p style={{ fontSize: '13px', lineHeight: '1.6', color: 'var(--text-secondary, #4a5568)', margin: 0 }}>
                    {f.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Team */}
          <div>
            <div style={{ textAlign: 'center', marginBottom: '40px' }}>
              <p style={sectionLabelStyle}>Our Team</p>
              <h2
                style={{
                  fontSize: '30px',
                  fontWeight: 800,
                  fontFamily: 'Manrope, sans-serif',
                  color: 'var(--navy, #0a192f)',
                  margin: 0,
                }}
              >
                Your Travel Consultants
              </h2>
              <p style={{ marginTop: '8px', fontSize: '14px', color: 'var(--text-secondary, #4a5568)' }}>
                Real people, real expertise — not chatbots or call centres.
              </p>
            </div>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isDesktop ? 'repeat(4, 1fr)' : '1fr',
                gap: '20px',
              }}
            >
              {consultants.map((c) => (
                <div
                  key={c.name}
                  style={{
                    padding: '20px',
                    borderRadius: '12px',
                    textAlign: 'center',
                    background: 'var(--white, #ffffff)',
                    border: '1px solid var(--border, #e2e8f0)',
                    boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                  }}
                >
                  <div
                    style={{
                      width: '64px',
                      height: '64px',
                      borderRadius: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '24px',
                      fontWeight: 700,
                      margin: '0 auto 16px auto',
                      background: 'rgba(0,0,0,0.07)',
                      color: 'var(--navy, #0a192f)',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    {c.name.split(' ').map((n) => n[0]).join('')}
                  </div>
                  <h3
                    style={{
                      fontWeight: 700,
                      fontSize: '14px',
                      marginBottom: '2px',
                      marginTop: 0,
                      fontFamily: 'Manrope, sans-serif',
                      color: 'var(--navy, #0a192f)',
                    }}
                  >
                    {c.name}
                  </h3>
                  <p style={{ fontSize: '12px', fontWeight: 600, marginBottom: '4px', marginTop: 0, color: 'var(--royal, #0f2744)', fontFamily: 'Manrope, sans-serif' }}>
                    {c.role}
                  </p>
                  <p style={{ fontSize: '11px', marginBottom: '12px', marginTop: 0, color: 'var(--text-muted, #718096)' }}>
                    {c.exp} · {c.location}
                  </p>
                  <p
                    style={{
                      fontSize: '11px',
                      padding: '2px 8px',
                      borderRadius: '9999px',
                      display: 'inline-block',
                      margin: 0,
                      background: 'rgba(244,123,32,0.1)',
                      color: 'var(--gold-dark, #d96614)',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    {c.speciality}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}